<template>
  <div>
    <com-search :columns="searchColumn" @search="handleSearch">
      <!-- <el-button type="primary" @click="handleExport">导出</el-button> -->
    </com-search>
  </div>
</template>

<script>
export default {
  props: {
    typeOfView: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchColumn: [
        {
          label: '订单号',
          prop: 'number',
          type: 'input'
        },
        {
          label: '套餐卡名称',
          prop: 'name',
          type: 'input'
        },
        {
          label: '用户手机号',
          prop: 'condition',
          type: 'input'
        },
        {
          label: '网点',
          prop: 'refStore',
          type: 'input'
        },
        {
          label: '开通时间',
          prop: 'date',
          type: 'date'
        }
      ]
    }
  },
  methods: {
    handleSearch(val) {
      this.$emit('search', val)
    },
    handleExport() {
      this.$emit('onExport')
    }
  }
}
</script>
